<template>
  <div class="authorization">
    <el-page-header @back="$router.go(-1)" content="小程序授权" style="margin-bottom: 20px;">
    </el-page-header>
    <div style="margin:30px 0;">
    当前职位：<label style="font-weight: bold;font-size: 24px;">{{pName}} （{{department}}） </label>
    </div>


    <div class="auth-check-container">
      <div v-for="item in auths" class="auth-row" >
        <div class="row-left first-title" >{{item.name}}</div>
        <div class="row-right">
        <!-- 二层 -->
          <div class="auth-row" v-for="sitem in item.children">
            <div class="row-left">
              <el-checkbox-group  :label=" String(sitem.id) " :key="sitem.id"
                     v-model="checkedCities"
                     @change="handleCheckedCitiesChange"
                   >
                     <el-checkbox  :label=" String(sitem.id) " :key="sitem.id">
                     {{sitem.name}}
                     {{sitem.remark}}
                     </el-checkbox>
                   </el-checkbox-group>
            </div>
            <div class="row-right">
              <!-- 三层 -->
               <div class="auth-row" v-for="ssitem in sitem.children">
                 <div class="row-left">
                   <el-checkbox-group  :label=" String(ssitem.id) " :key="ssitem.id"
                          v-model="checkedCities"
                          @change="handleCheckedCitiesChange"
                        >
                          <el-checkbox  :label=" String(ssitem.id) " :key="ssitem.id">
                          {{ssitem.name}}
                          {{ssitem.remark}}
                          </el-checkbox>
                        </el-checkbox-group>
                 </div>
                 <div class="row-right">
                   <!-- 四层 -->
                     <div class="auth-row" v-for="sssitem in ssitem.children">
                       <div style="width: 100%;">
                         <el-checkbox-group  :label=" String(sssitem.id) " :key="sssitem.id"
                                v-model="checkedCities"
                                @change="handleCheckedCitiesChange"
                              >
                                <el-checkbox  :label=" String(sssitem.id) " :key="sssitem.id">
                                {{sssitem.name}}
                                {{sssitem.remark}}
                                </el-checkbox>
                              </el-checkbox-group>
                       </div>

                     </div>
                   <!-- 四层 -->

                 </div>
               </div>

              <!-- 三层 -->

            </div>

          </div>
          <!-- 二层 -->
        </div>

      </div>

    </div>
<!--
    <template v-for="item in auths">
      <h3 style="margin-top: 20px;">{{item.name}}</h3>
      <el-checkbox-group  :label=" String(item.id) " :key="item.id"
        v-model="checkedCities"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox v-for="subitem in item.children" :label=" String(subitem.id) " :key="subitem.id">
        {{subitem.name}}
        {{subitem.remark}}
        </el-checkbox>
      </el-checkbox-group>
    </template> -->


    <div class="btn" style="display: flex;">
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button style="margin-left: 150px;" @click="$router.go(-1)" >返回</el-button>

    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      id: "",
      pName:"",//职位名称
      department:"",//部门
      checkAll: false,
      checkedCities: [],
      auths: [],
      isIndeterminate: true,

    };
  },
  activated() {
    if( typeof(this.$route.query.id) !=undefined && this.$route.query.id ) {
       this.id = this.$route.query.id;

       this.getData();
    }
    if( typeof(this.$route.query.pName) !=undefined && this.$route.query.pName ) {
       this.pName = this.$route.query.pName;
    }
    if( typeof(this.$route.query.department) !=undefined && this.$route.query.department ) {
       this.department = this.$route.query.department;
    }


  },
  methods: {
      submit(){
          this.post("architecture/updatePositionAuth", {auth:this.checkedCities,id:this.id}).then((res) => {
              if (res.data.code == 1) {
                Message.success(res.data.msg);
                var that = this;
                setTimeout(function () {
                  that.$router.go(-1);
                }, 1000);
              } else {
                Message.error(res.data.msg);
              }
            });
      },
      handleCheckedCitiesChange(value) {
        console.log(value);
        this.checkedCities=value
    },
    getData() {

      this.gets("architecture/getPositionAuthNew?id=" + this.id).then((res) => {
        let data = res.data.data;
        this.checkedCities = data.checkedAuth;
        this.auths = data.auths;

      });
    },
  },
};
</script>

<style scoped="scoped">
  .auth-check-container {
    border: 1px solid #EEEEEE;
  }

  .auth-check-container .auth-row{
    width: 100%;
    display: table;
    min-height: 40px;
    /* border: 1px solid #EEEEEE; */
  }
  .auth-check-container .auth-row .row-left{
    width: 250px;
    border-right: 1px solid #EEEEEE;
    border-bottom: 1px solid #EEEEEE;
    vertical-align: middle;
    display: table-cell;
  }
  .auth-check-container .auth-row .row-left.first-title{
    text-align: center;
  }
  .auth-check-container .auth-row .row-right{
     display: table-cell;
     /* width: 80%; */
     border-right: 1px solid #EEEEEE;
     border-bottom: 1px solid #EEEEEE;
  }

</style>



// WEBPACK FOOTER //
// src/view/entrepriseArchitecture/miniAuthorization.vue